<template>
    <div class="content-container border-alert-inset">
        <div class="font-weight-600 text-h6"><v-icon icon="mdi-alert" color="primary-dark"></v-icon> Lien privilégié
        </div>

        <div> Vous avez renseigné un lien privilégié pour ce module (code: {{ mainStore.inscription_vip.token }}).
            {{ mainStore.inscription_vip.get_status() }}
        </div>
    </div>
    <!-- <v-sheet class="bg-grey_2 rounded shadowed px-4 py-2 mt-2" variant="tonal">
            <div class="d-flex flex-wrap">
                <v-icon icon="mdi-alert" color="primary-dark" class="mr-2"></v-icon>
                <div>
                    Vous avez renseigné un lien privilégié pour ce module (code: {{ mainStore.inscription_vip.token }}).
                    {{ mainStore.inscription_vip.get_status() }}
                </div>
            </div>
        </v-sheet> -->
</template>

<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';
export default {
    computed: {
        ...mapStores(useMainStore)
    }

}
</script>

<style lang="scss" scoped></style>